
<template>
  <div class="fixed">
    <v-alert
      app
      v-if="company_data && company_data.status == 'on_trial' && days > 0 "
      type="info"
      dense
      border="bottom"
      icon="mdi-timer-play-outline"
    >
      <strong>Período de testes</strong> - {{ setDaysToMsg }}
    </v-alert>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: 'FusionOnTrialMessage',
  data() {
    return {
      msg: "Funcionalidade limitada",
      days: 7,
    };
  },
  methods: {
    setupDays(){
      if (this.company_data && this.company_data.trial){
        this.days = this.company_data.trial.days_duration
      }
    },
    
  },
  computed: {
    company_data() {
      if (this.oneUser && this.oneUser.company){
        return this.oneUser.company.data.attributes
      }
      return null 
    },
    setDaysToMsg() {
      this.setupDays()
      let days = 0 
      if (this.company_data.trial && this.company_data.trial.end_date){
        days = this.$moment(this.company_data.trial.end_date).diff(this.$moment(), 'days', false)
      } else {
        days = this.$moment().diff(this.$moment(this.company_data.created_at), 'days', false)
        
        days = this.days - days
      }
      this.days = days

      return `Seu período de teste termina em ${days} dia(s). Aproveite!` 
    },
    ...mapState({
      oneUser: state => state.User.oneUser,
      // token_access_token: state => state.User.token_access_token,
      allSolutions: state => state.Solution.allSolutions,
      loading_solutions: state => state.Solution.loading_solutions
    })
  },
  watch: {
    
  },
};
</script>

<style scoped>
.fixed {
  position: relative;
  width: 100%;
  z-index: 1;
}
</style>
